
import React from "react";

interface SiteLocationInfoProps {
  city: string;
  proximityInfo?: string;
}

const SiteLocationInfo: React.FC<SiteLocationInfoProps> = ({
  city,
  proximityInfo
}) => {
  return (
    <div className="text-center space-y-4">
      <p className="text-xl md:text-2xl text-fabre-lightgreen mb-8 font-medium">
        Centre de recyclage à {city}
      </p>
      
      {proximityInfo && (
        <p className="text-lg text-gray-200 max-w-2xl mx-auto leading-relaxed">
          {proximityInfo}
        </p>
      )}
    </div>
  );
};

export default SiteLocationInfo;
